/* =====================================================================
   Contact : choix du canal (message écrit | visio sur rendez-vous)

   Onglets ARIA : un seul formulaire visible à la fois, sous l'option choisie.
   Le message est actif par défaut (rendu serveur). Sont forcés sur le message :
   un retour de formulaire Shopify (?contact_posted, erreurs affichées) et un
   devis prérempli (?sujet=devis). Sinon #visio (ou #consultation) ouvre la
   réservation, depuis un lien externe comme depuis la page elle-même.
   ===================================================================== */

(function () {
  'use strict';

  var VISIO_HASHES = ['visio', 'consultation'];

  function init(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-contact-tab]'));
    if (tabs.length < 2) return;

    function panelFor(tab) {
      return document.getElementById(tab.getAttribute('aria-controls'));
    }

    function activate(name, options) {
      var opts = options || {};
      var changed = false;

      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-contact-tab') === name;
        var panel = panelFor(tab);
        if (on && tab.getAttribute('aria-selected') !== 'true') changed = true;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        tab.classList.toggle('is-active', on);
        if (panel) panel.hidden = !on;
      });

      var active = tabs.filter(function (tab) {
        return tab.getAttribute('data-contact-tab') === name;
      })[0];
      var activePanel = active ? panelFor(active) : null;

      if (changed && activePanel && opts.animate) {
        activePanel.classList.remove('is-entering');
        // Force le reflow pour rejouer l'animation à chaque changement d'onglet
        void activePanel.offsetWidth;
        activePanel.classList.add('is-entering');
      }

      if (opts.updateHash && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search + '#' + name);
      }

      // Le calendrier mesure son débordement au rendu : panneau masqué, la mesure
      // valait zéro. On relance le calcul maintenant qu'il est visible.
      if (changed) window.dispatchEvent(new Event('resize'));
    }

    function nameFromHash() {
      var hash = (window.location.hash || '').replace('#', '').toLowerCase();
      if (VISIO_HASHES.indexOf(hash) !== -1) return 'visio';
      if (hash === 'message') return 'message';
      return null;
    }

    function forcedToMessage() {
      var params;
      try {
        params = new URLSearchParams(window.location.search);
      } catch (e) {
        return false;
      }
      if (params.has('contact_posted') || params.get('sujet') === 'devis') return true;
      var messagePanel = document.getElementById('message');
      return !!(messagePanel && messagePanel.querySelector('.contact-page__errors, .contact-page__success'));
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-contact-tab'), { animate: true, updateHash: true });
      });

      // Flèches, Début, Fin : navigation clavier des onglets (activation automatique)
      tab.addEventListener('keydown', function (event) {
        var target = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = tabs[(index + 1) % tabs.length];
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = tabs[(index - 1 + tabs.length) % tabs.length];
        else if (event.key === 'Home') target = tabs[0];
        else if (event.key === 'End') target = tabs[tabs.length - 1];
        if (!target) return;
        event.preventDefault();
        target.focus();
        activate(target.getAttribute('data-contact-tab'), { animate: true, updateHash: true });
      });
    });

    var initial = forcedToMessage() ? 'message' : nameFromHash();
    if (initial) activate(initial);

    window.addEventListener('hashchange', function () {
      var name = nameFromHash();
      if (!name) return;
      activate(name, { animate: true });
      var panel = document.getElementById(name);
      if (panel) panel.scrollIntoView({ block: 'start' });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-contact-channels]').forEach(init);
  });
})();
